import axios from 'axios';
import qs from 'qs';
import { GetRegion } from 'constants.js';
import _ from 'lodash';

const api = axios.create({
  baseURL: process.env.URL_DOMINIO_MICROFWK,
});

export const updateDefaultsHBO = (axiosInstance, properties = {}) => {
  const instance = axiosInstance;
  const props = {};
  _.assign(props, properties);
  props.params.country_code = GetRegion();
  // invariant
  _.merge(instance.defaults, props);
  return instance;
};

export const getStartHeaderInfo = params =>
  api
    .get('/services/user/startheaderinfo', { params })
    .then(({ data }) => data);

export const getApaMetadata = params =>
  api.get('/services/apa/metadata', { params }).then(({ data }) => data);

export const getApaAssets = params =>
  api.get('/services/apa/asset', { params }).then(({ data }) => data);

export const postAuthHBOSSO = (body, params) =>
  api
    .post('/services/user/hbo/authenticationsso', qs.stringify(body), {
      params,
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    })
    .then(({ data }) => data);

export const postLoginHbo = (body, params) =>
  api
    .post('/services/user/hbo/authentication', qs.stringify(body), {
      params,
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    })
    .then(({ data }) => data);

export default api;
